export default "__VITE_ASSET__DaeNCTTo__"